export default __webpack_public_path__ + "static/media/harvestoptimization.49ae91a7.svg";